import {ProvidedService} from './provided-service';
import {AutoEletric} from './auto-eletric';

export class AutoEletricProvidedService {
  constructor(public id?: number,
              public price?: number,
              public providedService?: ProvidedService,
              public autoEletric?: AutoEletric) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/auto-eletric-provided-service.ts